import { action } from 'typesafe-actions';

import { PublishRulesActionsEnum } from 'PublishRulesPackage/MainModule/enums/publishRulesActionsEnum';
import { IPublishRules } from 'APIPackage/PublishRulesModule/interfaces/IPublishRules';
import { IKnmHistoryItemChanges } from 'KnmPackage/KnmHistoriesModule/interfaces/IKnmHistoryItemChanges';

import { MultipleHistoryChanges, PublishRulesForm, PublishRulesFormRef } from '../reducers/publishRulesReducer';
import { IPublishRulesTreeItem } from '../interfaces/IPublishRulesTreeItem';
import { PublishRulesCategoriesEnum } from '../enums/publishRulesCategoriesEnum';

export const setPublishRulesTree = (tree: IPublishRulesTreeItem[]) =>
  action(PublishRulesActionsEnum.PUBLISH_RULES_SET_TREE, {
    tree,
  });

export const setPublishRulesActiveTreeItem = (item: IPublishRulesTreeItem) =>
  action(PublishRulesActionsEnum.PUBLISH_RULES_SET_ACTIVE_TREE_ITEM, {
    item,
  });

export const updatePublishRulesActiveTreeItem = (item: IPublishRulesTreeItem) =>
  action(PublishRulesActionsEnum.PUBLISH_RULES_UPDATE_ACTIVE_TREE_ITEM, {
    item,
  });

export const setPublishRulesNextActiveTreeItem = (item?: IPublishRulesTreeItem) =>
  action(PublishRulesActionsEnum.PUBLISH_RULES_SET_NEXT_ACTIVE_TREE_ITEM, {
    item,
  });

export const setPublishRulesFormRef = (formRef?: PublishRulesFormRef) =>
  action(PublishRulesActionsEnum.PUBLISH_RULES_SET_FORM_REF, { formRef });

export const loadPublishRulesData = (category: PublishRulesCategoriesEnum) =>
  action(PublishRulesActionsEnum.PUBLISH_RULES_LOAD_DATA, { category });

export const setPublishRulesFormData = (formData?: IPublishRules) =>
  action(PublishRulesActionsEnum.PUBLISH_RULES_SET_FORM_DATA, { formData });

export const setPublishRulesHistory = (historyChanges: IKnmHistoryItemChanges[] | MultipleHistoryChanges) =>
  action(PublishRulesActionsEnum.PUBLISH_RULES_SET_HISTORY_CHANGES, { historyChanges });

export const setPublishRulesIsNeedSaveAccept = (isNeedSaveAccept?: boolean) =>
  action(PublishRulesActionsEnum.PUBLISH_RULES_SET_IS_NEED_SAVE_ACCEPT, { isNeedSaveAccept });

export const dropPublishRulesStateWithActiveTreeItemChange = () =>
  action(PublishRulesActionsEnum.PUBLISH_RULES_DROP_STATE_WITH_ACTIVE_TREE_ITEM_CHANGE);

export const getPublishRulesKnmStatuses = () => action(PublishRulesActionsEnum.PUBLISH_RULES_GET_KNM_STATUSES, {});
export const getPublishRulesErpStatuses = () => action(PublishRulesActionsEnum.PUBLISH_RULES_GET_ERP_STATUSES, {});
export const getPublishRulesPmStatuses = () => action(PublishRulesActionsEnum.PUBLISH_RULES_GET_PM_STATUSES, {});

export const fetchPublishRules = (code: string) => action(PublishRulesActionsEnum.PUBLISH_RULES_FETCH, { code });

export const fetchPublishRulesHistory = (code: string) =>
  action(PublishRulesActionsEnum.PUBLISH_RULES_FETCH_HISTORY, { code });

export const fetchPublishRulesSavedSettingsCategories = () =>
  action(PublishRulesActionsEnum.PUBLISH_RULES_FETCH_HAVE_SAVED_SETTINGS_CATEGORIES);

export const createOrUpdatePublishRules = (code: string, body: IPublishRules) =>
  action(PublishRulesActionsEnum.PUBLISH_RULES_CREATE_OR_UPDATE, { code, body });

export const deletePublishRules = (code: string, initialValues: PublishRulesForm) =>
  action(PublishRulesActionsEnum.PUBLISH_RULES_DELETE, { code, initialValues });
